import { gql } from 'graphql-tag';
export const createOecJob = gql`
  mutation createTrainingJob($input: CreateJobDataInput!) {
    createOecJob(input: $input) {
      success
      job {
        jobId: id
        state
        status
        type
        predictionId
      }
    }
  }
`;